import { render, staticRenderFns } from "./ContentShowDetailsRoute.vue?vue&type=template&id=896de6ae&scoped=true&"
import script from "./ContentShowDetailsRoute.vue?vue&type=script&lang=js&"
export * from "./ContentShowDetailsRoute.vue?vue&type=script&lang=js&"
import style0 from "./ContentShowDetailsRoute.vue?vue&type=style&index=0&id=896de6ae&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-2fffd51942/0/cache/vue-loader-npm-15.9.3-4ca89c7e4b-bc7d4c63e0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896de6ae",
  null
  
)

export default component.exports